import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';

import { AppBar, Toolbar, Typography, Button, IconButton, Container } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import MenuIcon from '@material-ui/icons/Menu';
import TodayIcon from '@material-ui/icons/Today';
import WorkIcon from '@material-ui/icons/Work';
import BookmarksIcon from '@material-ui/icons/Bookmarks';
import ReceiptIcon from '@material-ui/icons/Receipt';
import BlockIcon from '@material-ui/icons/Block';
import StarIcon from '@material-ui/icons/Star';
import LinkIcon from '@material-ui/icons/Link';
import qrIcon from '../assets/qrIcon.png'

import { Global, Constructors } from '../models/Global'
import AGTheme, { ThemeColors } from '../Theme'
import { DateConversions } from '../utils/DateConversions';
import { RestComponent, HomepageContext, PopupMenu, StyledTooltip, addCommonPortalMenuItems, OpenQRPopupWindow } from 'react-frontend-utils'
import { DatabaseSelectPopover } from '../components/DatabaseSelectPopover';
import { WelcomePage } from '../pages/WelcomePage'
import ExpiredPage from '../pages/ExpiredPage'
import CalendarPage from '../pages/CalendarPage'
import ServicesPage from '../pages/ServicesPage'
import SlotsListPage from '../pages/SlotsListPage'
import { Block } from '../models/Block'
import { Availability } from '../models/Availability';
import { logo } from '../App'


//This is the main page for the Web Portal. It contains the AppBar and MainMenu and handles login/logout.
//Below the AppBar, the HomePage selects one Page out of the available Pages to display, based on what
//is selected by the user. The WecomePage is the initial page shown before login.


//These are the available Pages that can be selected from the MainMenu that will be displayed below the AppBar
export const Pages = {
    EMPTY:  "EMPTY",
    WELCOME: "WELCOME",
    EXPIRED: "EXPIRED",
    CALENDARS: "CALENDARS",
    SERVICES: "SERVICES",
    BOOKINGS: "BOOKINGS",
    EVENTS: "EVENTS",
    AVAILABILITY: "AVAILABILITY",
    BLOCKS: "BLOCKS",
    
    //Returns true if the type is one of the MainMenuSwitch types, false otherwise
    isOneOf: (type) => {
        switch (type) {
            case Pages.EMPTY:
            case Pages.WELCOME:
            case Pages.EXPIRED:
            case Pages.CALENDARS:
            case Pages.SERVICES:
            case Pages.BOOKINGS:
            case Pages.EVENTS:
            case Pages.AVAILABILITY:
            case Pages.BLOCKS:
                return true;
            default:
                return false;
        }
    }
};
Object.freeze(Pages);



const AppBarIconButton = withStyles((theme) => ({
    root: {
        '&:hover': {backgroundColor: ThemeColors.lightTooltipHover}
    }
}))(IconButton);

const AppBarButton = withStyles((theme) => ({
    root: {
        '&:hover': {backgroundColor: ThemeColors.lightTooltipHover}
    }
}))(Button);


class Home extends RestComponent {
  
  
    styles = {
        appTitle: {
           marginLeft: 10,
           textShadow: "2px 2px #333333",
           fontWeight: "bold",
           fontSize: "200%",
           flexGrow: 1   //fill all space to push other elements to the right edge
        }
    }
 
    _databaseChangedEvent;
    _initialSlotId;
    _nowTimeInterval;

    constructor(props) {
        super(props);
        const database = props.database ? decodeURIComponent(props.database) : null;  //Arrives with the query string set to the desired database
        if (database)
            Global.setLastDatabase(database);

        this.state.isAuthenticated = false;       //true if the current user has been authenticated via OAuth
        this.state.serverError = null;
        this.state.isMobile = false;
        this.state.currentUser = null;
        this.state.selectedPage = Pages.WELCOME;  //default
        this.state.databasePopoverOpen = false;
        this.state.manageServiceId = null;
        this.state.calendarInitialView = null;
        this._initialSlotId = props.slotid ? decodeURIComponent(props.slotid) : null;
        this.state.eventid = props.eventid ? decodeURIComponent(props.eventid) : null;

        this.state.highlightedSlot = null;  //slot to highlight in the calendar view
        this.state.editHighlightedSlot = false;    // if true, edit the highlighted slot

        this.state.nowTimeStr = "asdfasd";

        this.state.bookingPortalEnabled = false;
        this._databaseChangedEvent = new Event('databaseChangeEvent');
    }


    /**
     * When the Home page loads, see if the user is currently authenticated
     */
    componentDidMount() {
        super.componentDidMount();
        this._updateSize();
        this._updateNowTimeStr();
        this._nowTimeInterval = setInterval(this._updateNowTimeStr, 1000);
        window.addEventListener("resize", this._updateSize);
        this.getLoggedInUser(this._loggedInUserCallback);
    }
  
    componentWillUnmount() {
        super.componentWillUnmount();
        clearInterval(this._nowTimeInterval);
        window.removeEventListener("resize", this._updateSize);
    }

    //callback when window changes size
    _updateSize = () => {
        this.setState({ isMobile: window.innerWidth < 600 });  //custom, split between bootstrap and mui
    }


    /**
     * Callback to be executed from fetching the current user
     * @param {User} user null if there is no current authenticated user, or a User object describing the user
     */
    _loggedInUserCallback = (user) => {
        if (user === null) {
            this.setState(({isAuthenticated: false, currentUser: null}));  //user is not authenticated
            Global.user = null;     
        } 
        else {
            this.setState({currentUser: user, isAuthenticated: true});
            Global.user = user;

            let lastDatabase = Global.getLastDatabase();
            if (!lastDatabase || !user.databases.includes(lastDatabase)) {  // if no last database, or user doesn't have last database, use their first
                lastDatabase = Global.user.databases[0];  //use first
                console.log("No last database set, last database unavailable, now using " + lastDatabase);
                Global.setLastDatabase(lastDatabase);
            }
            this._changeDatabase(lastDatabase, true);      
        }
        Global.copiedEventSettings = null;      // clear any copied event settings on login
    }

   

    /**
     * User action by pressing the LOGOUT button
     */
    logout() {
        super.logout( () => {
            this.setState({currentUser: null, isAuthenticated: false, manageServiceId: null});
            Global.user = null;
        });
    }
    
    sessionExpired = () => {
        this.setState({selectedPage: Pages.EXPIRED, currentUser: null, isAuthenticated: false});
    }

    
    /**
     * Callback from the MainMenu component when a user selects an item from the menu 
     * @param {Pages item} selectedItem one of the Pages items
     */
    mainMenuCallback = (selectedItem) => {
        
        if (Pages.isOneOf(selectedItem)) {
            this.setState({selectedPage: selectedItem}); 
            console.log("Switching page to " + selectedItem);
        }
        else {
            console.log("Invalid Page passed to mainMenuCallback");
        }
    }

    _gotoCalendarsPage = (slot, editHighlightedSlot, view) => {
        this.setState({selectedPage: Pages.CALENDARS, highlightedSlot: slot, editHighlightedSlot: editHighlightedSlot, calendarInitialView: view, });
    }

    _gotoServicesPage = (id) => {
        this.setState({selectedPage: Pages.SERVICES, manageServiceId: id});
    }
    
    _gotoBookingsPage = () => {
        this.setState({selectedPage: Pages.BOOKINGS});
    }

    _gotoEventsPage = (id) => {
        if (id)
            this.props.history.push("/bkportal?eventid=" + id);
        else
            this.props.history.push("/bkportal");
        this.setState({selectedPage: Pages.EVENTS, eventid: id});
    }

    _mainMenu = () => {
  
        const items = (() => {

            let menuItems = [];

            if (this.state.bookingPortalEnabled) {
                menuItems.push({label: "Calendar", 
                                icon: <TodayIcon fontSize="small"/>, 
                                isSelected: (this.state.selectedPage === Pages.CALENDARS), 
                                selectCallback: this._gotoCalendarsPage
                                });
                        
                menuItems.push({label: "Services", 
                    icon: <WorkIcon fontSize="small"/>, 
                    isSelected: (this.state.selectedPage === Pages.SERVICES), 
                    selectCallback: this._gotoServicesPage
                    });

                menuItems.push({label: "Bookings",
                    icon: <BookmarksIcon fontSize="small"/>,
                    isSelected: (this.state.selectedPage === Pages.BOOKINGS),
                    selectCallback: this._gotoBookingsPage
                });

                menuItems.push({label: "Events",
                    icon: <ReceiptIcon fontSize="small"/>,
                    isSelected: (this.state.selectedPage === Pages.EVENTS),
                    selectCallback: this._gotoEventsPage
                });

                menuItems.push({label: "Availabilities",
                    icon: <StarIcon fontSize="small"/>,
                    isSelected: (this.state.selectedPage === Pages.AVAILABILITY),
                    selectCallback: () => this.setState({selectedPage: Pages.AVAILABILITY})
                });

                menuItems.push({label: "Blocks",
                    icon: <BlockIcon fontSize="small"/>,
                    isSelected: (this.state.selectedPage === Pages.BLOCKS),
                    selectCallback: () => this.setState({selectedPage: Pages.BLOCKS})
                });

                menuItems.push(null);
            }
            
            addCommonPortalMenuItems(menuItems, this.state.currentUser, "booking");

            return menuItems;
        })();

        return <PopupMenu menuIcon={<MenuIcon/>} menuItems={items} lighterHover={true}/>;
    }

    _linksMenu = () => {
  
        const items = (() => {
            let menuItems = [];

            if (this.state.bookingPortalEnabled) {
                menuItems.push({label: "iCal Internal Subscription", selectCallback: this._getIcalSubscription});               
                menuItems.push({label: "iCal Public Subscription", selectCallback: this._getPublicIcalSubscription});            
                menuItems.push(null);
                menuItems.push({label: "Patron Service Booking Page", selectCallback: this._getPatronBookingLink});
                menuItems.push({label: "Patron Event Signup Page", selectCallback: this._getEventSignupLink});
            }
            return menuItems;
        })();

        return <PopupMenu menuIcon={<LinkIcon/>} menuItems={items} lighterHover={true}/>;
    }


    _showHealth = () => {
        let port = (window.location.port ? ':' + window.location.port : '');
        if (port === ":3000") {
            port = ":8080";  //switch to 8080 if using yarn development port
        }
        window.location.href = "//" + window.location.hostname + port + "/monitoring"; 
    }
    
    _showLogs = () => {
        let port = (window.location.port ? ':' + window.location.port : '');
        if (port === ":3000") {
            port = ":8080";  //switch to 8080 if using yarn development port
        }
        window.location.href = "//" + window.location.hostname + port + "/actuator/logfile"; 
    }

    
    _changeDatabase = (database) => {
        this.setState({databasePopoverOpen: false});

        console.log("New database is " + database);

        Global.setLastDatabase(database);

        this.incrementBusy();

        //Fetch database - is it enabled for booking?
        this.secureJSONFetch("/bk/" + database + "/enabled", {}, this._fetchDBEnabledCallback, this._fetchDBFailCallback); 
    }

    // success - we are ok to proceed with booking on this database
    _fetchDBEnabledCallback = (response) => {
        this.incrementBusy();
        this.setState({bookingPortalEnabled: true});

        // Fetch the timezone for the current database
        this.incrementBusy();
        this.secureJSONFetch("/tz/" + Global.getLastDatabase(), {}, this._fetchTimezoneCallback, this._fetchErrorCallback);
    }

    // When the timezone is fetched, update the timezone state, if none is set, show an alert, and set the default timezone to America/New_York
    _fetchTimezoneCallback = (response) => {
        this.decrementBusy();
        if (response) {
            if (response.group !== Global.getLastDatabase()) {
                this.showConfirmAlert("Error", "Timezone response for wrong database", 'red');
                return;
            }
            if (!response.timezone) {
                this.showConfirmAlert("No Timezone Set", "Please set your community's timezone. Until changed, the default timezone will be America/New_York", 'red');
                Global.setTimezone(Global.DEFAULT_TIMEZONE);
                Global.timezoneNotSet = true;
            }
            else
                Global.setTimezone(response.timezone);

            if (this.state.eventid)
                this.setState({selectedPage: Pages.EVENTS});
            else {
                if (this._initialSlotId) {   // first fetch the slot before showing the Calendar page
                    this.secureJSONFetch("/bk/slots/" + this._initialSlotId, {}, this._fetchInitialSlotCallback, this._fetchErrorCallback); 
                    this.setState({selectedPage: Pages.EMPTY});
                }
                else
                    this.setState({selectedPage: Pages.CALENDARS});
            }

            dispatchEvent(this._databaseChangedEvent);   //let everyone know the database has changed!         }   
        }
    }

    // callback when fetching the initial slot to highlight in the calendar
    _fetchInitialSlotCallback = (response) => {
        const slot = Constructors.slotFromJson(response, Global.getTimezone());
        const view = slot instanceof Block || slot instanceof Availability ? 'timeGridWeek' : 'dayGridYear';
        this.setState({highlightedSlot: slot, selectedPage: Pages.CALENDARS, calendarInitialView: view});
    }

    // fail - database not found, or not authorized yet
    _fetchDBFailCallback = (error) => {
        this.showConfirmAlert("Error", error, 'red');
        this.decrementBusy();
        this.setState({selectedPage: Pages.EMPTY, bookingPortalEnabled: false});    
    }


    _fetchErrorCallback = (error) => {
        this.showConfirmAlert("Error", error, 'red');
        this.decrementBusy();
    }

    //--------------------------------------------------------------------------------------------------------------------------
    //------------------------------------------ SUBSCRIPTION MANAGEMENT -------------------------------------------------------
    //--------------------------------------------------------------------------------------------------------------------------

    _getIcalSubscription = () => {
        this.incrementBusy();
        this.secureJSONFetch("/bk/ical/" + Global.getLastDatabase(), {}, this._getIcalSubscriptionCallback, this._fetchErrorCallback);
    }

    _getIcalSubscriptionCallback = (response) => {
        this.decrementBusy();
        if (response) {
            const link = "https://booking.accessgrantedsystems.net/ical/" + response.subscriptionKey;
            const msg = <span>
                            Copy the following URL to your calendar application to subscribe to your internal Calendar (all Events and Bookings). 
                            <span style={{fontWeight: 'bold', color: 'red'}}> Do not share this link with patrons.</span> Only share this link with
                            people who are authorized to view all community Events (including private Events) and all patron Bookings (usually your staff).<br/><br/>
                            <a href={link} style={{color: 'blue'}} target="_blank" rel="noopener noreferrer">{link}</a>
                        </span>;
            this.showConfirmAlert("iCal Internal Subscription", msg, 'black', "Ok", this._rekeyICalSubscription, "Re-key", 'red');
        }
    }

    _rekeyICalSubscription = () => {
        this.showConfirmAlert("Regenerate Internal Subscription Link", "Are you sure you want to regenerate the Subscription Link? Any subscribers will need to re-subscribe with the new link.",
            'black',
            "Cancel", 
            this._confirmRekey,
            "Re-key",
            'red');
    }

    _getPublicIcalSubscription = () => {
        this.incrementBusy();
        this.secureJSONFetch("/bk/ical/" + Global.getLastDatabase() + "/public", {}, this._getIcalPublicSubscriptionCallback, this._fetchErrorCallback);
    }


    _confirmRekey = () => {
        this.incrementBusy();
        this.secureJSONFetch("/bk/ical/" + Global.getLastDatabase(), {method: 'POST'}, this._getIcalSubscriptionCallback, this._fetchErrorCallback);
    }


    _linkPopup = (title, msgText, link) => {
        const msg = <span>
                        {msgText}<br/><br/>
                        <a href={link} style={{color: 'blue'}} target="_blank" rel="noopener noreferrer">{link}</a>
                        <div style={{display: "flex", justifyContent: "center", marginTop: 15}}>
                            <Button onClick={() => OpenQRPopupWindow(title, link)} variant="outlined">
                                <img src={qrIcon} alt="QR Icon" style={{ width: 20, height: 20, paddingRight: 5 }}/>
                                Get QR Code
                            </Button>
                        </div>
                    </span>;
        this.showConfirmAlert(title, msg, 'black');
    }

    _getIcalPublicSubscriptionCallback = (response) => {

        this.decrementBusy();
        if (response) {
            const title = "iCal Public Subscription";
            const msg = "Copy the following URL to your calendar application to subscribe to the community's Public Calendar (all public Events). You may share this link with " +
                        "your patrons to allow them to subscribe for public Events."
            const link = "https://booking.accessgrantedsystems.net/ical/" + Global.getLastDatabase() + "/" + response.subscriptionKey;
            this._linkPopup(title, msg, link);
        }
    }

    _getPatronBookingLink = () => {
        const title = "Patron Booking";
        const msg = "The following URL can be shared with your Patrons to allow them to book your Services:";
        const link = "https://booking.accessgrantedsystems.net/patron/booking?database=" + Global.getLastDatabase();
        
        this._linkPopup(title, msg, link);
    }

    _getEventSignupLink = () => {   
        const title = "Patron Event Signup";
        const msg = "The following URL can be shared with your Patrons to allow them to sign up for your public Events:";
        const link = "https://booking.accessgrantedsystems.net/patron/event?database=" + Global.getLastDatabase();
       
        this._linkPopup(title, msg, link);
    }
    
    _updateNowTimeStr = () => {
        const now = DateConversions.now(Global.getTimezone());
        const components = DateConversions.dateTimeStrComponents(now);
        
        this.setState({nowTimeStr: "Portal Time: " + components.dateStr + " " + components.timeStr});
    }

    render() {

        //Set the login button based on the state of the authentication
        const loginLogoutButton = this.state.isAuthenticated ?
            <AppBarButton color="inherit" onClick={() => { this.logout(); }}>LOGOUT</AppBarButton>
            :
            <AppBarButton color="inherit" onClick={() => { this.login(); }}>LOGIN</AppBarButton>;


        //Only shows the main menu when authenticated 
        const showMainMenu = this.state.isAuthenticated;

           
        //Selects the current page to view
        const viewingPage = (() => {
                       
            switch (this.state.selectedPage) {

                case Pages.EMPTY:
                    return <div/>

                case Pages.WELCOME:   
                    return <WelcomePage loginFunc={(provider) => this.login(provider)}/>;
              
                case Pages.EXPIRED:   
                    return <ExpiredPage/>;
                    
                case Pages.CALENDARS:
                    return <CalendarPage manageServiceCallback={this._gotoServicesPage} manageEventSignupCallback={this._gotoEventsPage} 
                                                                initialView={this.state.calendarInitialView}                      
                                                                highlightedSlot={this.state.highlightedSlot}
                                                                editHighlightedSlot={this.state.editHighlightedSlot}/>;

                case Pages.SERVICES:
                    return <ServicesPage manageServiceId={this.state.manageServiceId}/>;

                case Pages.BOOKINGS:
                    return <SlotsListPage type="Booking" viewSlotInCalendarCallback={this._gotoCalendarsPage}/>;

                case Pages.EVENTS:
                    return <SlotsListPage type="Event" eventid={this.state.eventid} viewSlotInCalendarCallback={this._gotoCalendarsPage}/>;

                case Pages.AVAILABILITY:
                    return <SlotsListPage type="Availability" viewSlotInCalendarCallback={(slot, doEdit) => this._gotoCalendarsPage(slot, doEdit, 'timeGridWeek')}/>;
                    
                case Pages.BLOCKS:
                    return <SlotsListPage type="Block" viewSlotInCalendarCallback={(slot, doEdit) => this._gotoCalendarsPage(slot, doEdit, 'timeGridWeek', )}/>;

                default:
                    return <div>Page Not Found</div>;

            }
        })();
        
        const serverErrorMessage = this.state.serverError ? <Typography variant="h5">Server Error: {this.state.serverError}</Typography> : null;
      
        const gutterMargin = this.state.isMobile ? 8 : 20;
        
        return (
            <HomepageContext.Provider value={{sessionExpiredCallback: this.sessionExpired}}>
    
                <ThemeProvider theme={AGTheme}>
                    <Fragment>

                        {this.getConfirmAlertComponent()  /*inject an alert component*/}  

                        {Global.user ? 
                            <DatabaseSelectPopover isOpen={this.state.databasePopoverOpen} okCallback={(database) => this._changeDatabase(database)} 
                                                  cancelCallback={() => this.setState({databasePopoverOpen: false})}/>   
                                : null
                        }
                        
                        <AppBar position="static" style={{marginBottom: 12, backgroundColor: ThemeColors.appBarBackground}}>
                            <div style={{paddingTop: 0, paddingBottom: 4, paddingLeft: gutterMargin, paddingRight: gutterMargin}}>

                                <Toolbar disableGutters={true}>
                                    {logo}
                                    <Typography variant="h5" style={this.styles.appTitle}>Booking Portal</Typography>

                                    {Global.user && Global.user.databases.length > 1 ? 
                                        <StyledTooltip title="Switch Database">
                                            <AppBarButton color="inherit" style={{marginRight: 30}} onClick={() => this.setState({databasePopoverOpen: true})}>⇋ DATABASE</AppBarButton>
                                        </StyledTooltip>
                                        : null
                                    }
                                    {showMainMenu ? this._linksMenu() : null}
                                    <div style={{padding: 5}}/>

                                    {this.state.currentUser && this.state.currentUser.isSuperAdmin(true) ? 
                                        <div>
                                            <AppBarIconButton edge="end" onClick={this._showLogs} style={{marginRight: 5}} >
                                                <DescriptionOutlinedIcon fontSize="small" style={{color: 'white'}}/>
                                            </AppBarIconButton>
                                            <AppBarIconButton edge="end" onClick={this._showHealth} style={{marginRight: 5}} >
                                                <FavoriteBorderIcon fontSize="small" style={{color: 'white'}}/>
                                            </AppBarIconButton>
                                        </div>
                                        : null
                                    }
                                    
                                    
                                    {loginLogoutButton}
                                    <div style={{padding: 5}}/>
                                    {showMainMenu ? this._mainMenu() : null}


                                </Toolbar>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end'}}>
                                    <div style={{display: "flex", flexDirection: 'column'}}>
                                        <Typography variant="subtitle1" style={{textAlign: 'left', fontSize: this.state.isMobile ? 13 : 16}}>{this.state.currentUser ? ("User: " + this.state.currentUser.name()) : null}</Typography>
                                        <Typography variant="subtitle1" style={{textAlign: 'left', fontSize: this.state.isMobile ? 13 : 16}}>{this.state.currentUser ? ("Database: " + Global.getLastDatabase()) : null}</Typography>
                                    </div>
                                    {Global.user ?
                                        <div>
                                            <Typography variant="subtitle1" style={{textAlign: 'right', fontSize: this.state.isMobile ? 13 : 16}}>{this.state.nowTimeStr}</Typography>
                                        </div>
                                        : null
                                    }
                                </div>
                            </div>
                        </AppBar>


                        {serverErrorMessage}
                        
                        <Container maxWidth={false} disableGutters={true} style={{paddingLeft: gutterMargin, paddingRight: gutterMargin}}>
                            {viewingPage} 
                        </Container>

                    </Fragment>
                </ThemeProvider>    
            </HomepageContext.Provider>
        );
    }
};

export default withCookies(withRouter(Home));

